import {Location, LocationLanguageTranslation, LocationTranslations} from '../common/types/location'
import {GQL_LocationFragment, GQL_LocationLanguageTranslation, GQL_LocationTranslations} from '../generated/graphql'

const transformLocationLanguageTranslation = (t: GQL_LocationLanguageTranslation | null | undefined): LocationLanguageTranslation | undefined => {
  if (!t) return undefined
  return {description: t.description ?? undefined}
}

const transformLocationTranslations = (t: GQL_LocationTranslations | null | undefined): LocationTranslations | undefined => {
  if (!t) return undefined
  return {
    en: transformLocationLanguageTranslation(t.en),
    sv: transformLocationLanguageTranslation(t.sv),
    no: transformLocationLanguageTranslation(t.no),
    da: transformLocationLanguageTranslation(t.da),
  }
}

export const transformLocation = (location: GQL_LocationFragment): Location => {
  return {
    id: location.id,
    coordinates: location.coordinates ?? undefined,
    description: location.description ?? undefined,
    locality: location.locality ?? undefined,
    municipality: location.municipality ?? undefined,
    name: location.name ?? undefined,
    translations: transformLocationTranslations(location.translations),
  }
}
